module.exports = __webpack_public_path__ + "VIPV19.png?f8aba2368a679a17edeb5c831329a154";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/colours/horses/VIPV19.png
// module id = 113
// module chunks = 0